import React, { createContext, useContext, useState, ReactNode } from 'react';

interface CustomerFilter {
  customerId: string | null;
  customerName: string | null;
  isFiltered: boolean;
}

interface CustomerFilterContextType extends CustomerFilter {
  setCustomerFilter: (customerId: string | null, customerName: string | null) => void;
  clearCustomerFilter: () => void;
}

const CustomerFilterContext = createContext<CustomerFilterContextType | undefined>(undefined);

export const useCustomerFilterContext = () => {
  const context = useContext(CustomerFilterContext);
  if (!context) {
    throw new Error('useCustomerFilterContext must be used within CustomerFilterProvider');
  }
  return context;
};

interface CustomerFilterProviderProps {
  children: ReactNode;
}

export const CustomerFilterProvider: React.FC<CustomerFilterProviderProps> = ({ children }) => {
  const [customerId, setCustomerId] = useState<string | null>(null);
  const [customerName, setCustomerName] = useState<string | null>(null);

  const setCustomerFilter = (id: string | null, name: string | null) => {
    setCustomerId(id);
    setCustomerName(name);
  };

  const clearCustomerFilter = () => {
    setCustomerId(null);
    setCustomerName(null);
  };

  const value: CustomerFilterContextType = {
    customerId,
    customerName,
    isFiltered: customerId !== null,
    setCustomerFilter,
    clearCustomerFilter,
  };

  return (
    <CustomerFilterContext.Provider value={value}>
      {children}
    </CustomerFilterContext.Provider>
  );
};